// iconMap.js
// Maps the icon `name` saved by components/icon-selectbox-new.js to its HeroSmall component.
// "none" is intentionally absent so it renders no icon.
import {
  Tag,
  GlobeAsiaAustralia,
  GlobeAmericas,
  LightBulb,
  GlobeAlt,
  Fire,
  AdjustmentsHorizontal,
  Identification,
  FingerPrint,
  CogSixTooth,
  Camera,
  Calculator,
  CalendarDays,
  BuildingLibrary,
  Bolt,
  AcademicCap,
  Sparkles,
  RocketLaunch,
  BuildingOfficeTwo,
  ClipboardDocument,
  CurrencyDollar,
  ExclamationTriangle,
  HandRaised,
  Keys,
  Users,
  User,
  Wallet,
  HomeModern,
  Home,
  Scale,
  Banknotes,
  ChatBubbleLeft,
} from './HeroSmall.js';

export const iconMap = {
  Tag,
  GlobeAsiaAustralia,
  GlobeAmericas,
  LightBulb,
  Lightbulb: LightBulb, // older saves used this spelling
  GlobeAlt,
  Fire,
  AdjustmentsHorizontal,
  Identification,
  FingerPrint,
  CogSixTooth,
  Camera,
  Calculator,
  CalendarDays,
  BuildingLibrary,
  Bolt,
  AcademicCap,
  Sparkles,
  RocketLaunch,
  BuildingOfficeTwo,
  ClipboardDocument,
  CurrencyDollar,
  ExclamationTriangle,
  HandRaised,
  Keys,
  Users,
  User,
  Wallet,
  HomeModern,
  Home,
  Scale,
  Banknotes,
  ChatBubbleLeft,
};
